<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-lookup"></require>

  <div>
    <div class="form-row">
      <div class="col-md-6 ${!model.isActive ? 'sc-archived' : ''}">
        <bs-form-input type="text" label="Region Name" placeholder="Region name" value.bind="model.region & validate" disabled.bind="!model.isActive" maxlength="500"></bs-form-input>
      </div>
      <div class="${!model.isActive ? 'col-md-3 sc-archived' : 'col-md-6'}">
        <bs-form-lookup label.bind="userGroupLabel" placeholder="Surname, login or email" item.bind="model.director & validate" options.bind="usersLookupOptions" value-path="name" template-path="templates/user-lookup.html" stick-mode="true" disabled.bind="!model.isActive" tooltip="Type to search for bp employee, then pick the one from the list"></bs-form-lookup>
      </div>
      <div class="col-md-3" if.bind="model.archivedOn">
        <bs-form-input type="text" label="Archived by ${model.archivedBy.fullName || model.archivedBy.loginName}" value.bind="model.archivedOn | dateTime" disabled="true"></bs-form-input>
      </div>
    </div>
  </div>
</template>
